<template>
  <el-container>
    <el-card shadow="never" style="width: 100%;" :body-style="{padding:0,border:0}">
      <template slot="header">
        所有menu列表
      </template>
      <el-table
        style="border-top:0;border-bottom: 0;"
        :border="true"
        :data="menuList"
        size="medium"
        v-loading="loading"
        element-loading-text="玩命加载中..."
      >
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column prop="role.name"
                         label="角色"></el-table-column>
        <el-table-column prop="name"
                         label="菜单名(EN)"></el-table-column>
        <el-table-column prop="display_name"
                         label="显示名"></el-table-column>
        <el-table-column prop="sort"
                         label="排序"></el-table-column>
        <el-table-column prop="path"
                         label="路径"></el-table-column>
        <el-table-column prop="url"
                         label="网址"></el-table-column>
        <el-table-column prop="component"
                         label="组件"></el-table-column>
        <el-table-column prop="icon"
                         label="图标"></el-table-column>
        <el-table-column prop="position"
                         label="位置组"></el-table-column>
        <el-table-column prop="desc"
                         label="描述"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-search"
                       @click="show(scope.row)"></el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete"
                       @click="destory(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float: right"
        @current-change="setpage"
        layout="prev, pager, next"
        :current-page="page.currentPage"
        :page-size="page.pageSize"
        :total="page.total">
      </el-pagination>
    </el-card>
  </el-container>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "Menu",
    created() {
      this.$store.dispatch('menu/getList');
      let vthis = this;
    },
    computed: {
      ...mapState({
        menuList: state => state.menu.list,
        page: state => state.menu.page,
        loading: state => state.menu.loading
      })
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions({
        destory: 'menu/destory'
      }),
      setpage(pageNow) {
        let page = this.page;
        page.currentPage = pageNow;

        this.$store.dispatch('menu/getList', page)
      },
      show(row) {
        this.$router.push({
          name: 'MenuEdit',
          params: {
            id: row.id
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/menu/Menu.vue